import { isRichHtml, sanitizeRichHtml } from '../lib/richText'

/** Admin HTML is sanitized before insertion. Plain legacy text stays plain. */
export default function RichContent({value,className=''}:{value:string|null|undefined;className?:string}){
  const input=String(value||'')
  if(!isRichHtml(input))return <div className={`rich-content ${className}`}>{input.split(/\n{2,}/).filter(Boolean).map((paragraph,i)=><p key={i} style={{whiteSpace:'pre-line'}}>{paragraph}</p>)}</div>
  return <div className={`rich-content ${className}`} dangerouslySetInnerHTML={{__html:sanitizeRichHtml(input)}}/>
}
